import React from 'react';
import PropTypes from 'prop-types';
import { FlexRow } from 'design-system';

export default function QuizProgressSegments({ total, activeIndex }) {
  if (!total) {
    return null;
  }

  return (
    <FlexRow
      align="stretch"
      fullWidth
      gap="var(--ds-space-1)"
      className="ld-quiz__segments"
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={total}
      aria-valuenow={activeIndex + 1}
      aria-label={`Question ${activeIndex + 1} of ${total}`}
    >
      {Array.from({ length: total }, (_, index) => (
        <span
          key={index}
          className={[
            'ld-quiz__segment',
            index <= activeIndex ? 'ld-quiz__segment--filled' : '',
          ]
            .filter(Boolean)
            .join(' ')}
          aria-hidden
        />
      ))}
    </FlexRow>
  );
}

QuizProgressSegments.propTypes = {
  total: PropTypes.number.isRequired,
  activeIndex: PropTypes.number.isRequired,
};
